export const ASIAN_MARKETS: { [key: string]: string } = {
  'Goals Asian Handicap': 'AsianHandicap2',
  'Total Goals Asian': 'OverUnder2',
  '1st Half Goals Asian Handicap': 'HalfTimeAsianHandicap2',
  '2nd Half Goals Asian Handicap': '2ndHalfAsianHandicap2'
};
